import { render } from "./companies.vue?vue&type=template&id=3ce0c148&scoped=true"
import script from "./companies.vue?vue&type=script&lang=js"
export * from "./companies.vue?vue&type=script&lang=js"

import "./companies.vue?vue&type=style&index=0&id=3ce0c148&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ce0c148"]])

export default __exports__